<template>
	<Layout>
		<Sider hide-trigger class="sider">
			<Menu :accordion="true" active-name="0-0" theme="dark" width="auto" :open-names="['1']">
				<Submenu name="1">
					<template slot="title">
						<Icon type="ios-paper" />
						{{$tt('设备管理')}}
					</template>
					<router-link to='/mg/device'>
						<MenuItem name="1-1">{{$tt('设备管理')}}</MenuItem>
						<MenuItem name="1-2">{{$tt('设备管理')}}</MenuItem>
						<MenuItem name="1-3">{{$tt('设备管理')}}</MenuItem>
					</router-link>
				</Submenu>
				<router-link to='/mg/task'>
					<MenuItem name="2">
					<Icon type="md-document" />
					{{$tt('押解任务')}}
					</MenuItem>
				</router-link>
			</Menu>
		</Sider>
		<Layout :style="{padding: '0 10px',height:'100%'}">
			<Content :style="{padding: '0px'}">
				<router-view :key="viewKey"></router-view>
			</Content>
		</Layout>
	</Layout>
</template>

<script>
	import Menu from '../../../router.js';
	import {
		langState
	} from '../../../language'
	export default {
		//props:['MenuList'],
		data() {
			return {
				MenuList: [],
				Menu: Menu,
			};
		},
		computed: {
			//路由出口 key：路径 + 语言版本，切换语言时重建页面
			viewKey() {
				return this.$route.fullPath + '|' + langState.version
			}
		},
		//监听地址栏变化，菜单变动
		watch: {
			$route(to, from) {
				///AnMeng/MapSilder/
				const path = to.path.split('/');
				for (let i = 0; i < this.Menu.length; i++) {
					if (this.Menu[i].path == "/" + path[1]) {
						this.MenuList = [];
						this.MenuList.push(this.Menu[i]);
					}
				}
			}
		},
		//首次加载不触发 watch 挂载时主动查发一次
		created: function() {
			const path = this.$route.path.split('/');
			for (let i = 0; i < this.Menu.length; i++) {
				if (this.Menu[i].path == "/" + path[1]) {
					this.MenuList = [];
					this.MenuList.push(this.Menu[i]);
				}
			}
		}
	}
</script>

<style>
	.menuDiv {
		height: 50px;
		width: 90%;
		text-align: center;
		line-height: 50px;
	}
</style>
